<template>
    <div class="menu-page">
        <div v-if="currentUser.account.max_channels == 1">
            <v-alert class="fade" dense text type="warning">
                Funcionalidade indisponível neste plano. Por favor, faça upgrade para o plano Profissional ou superior.
                <ib-btn class="ml-2" color="warning" @click.native="$router.push('/minha-conta')">
                    Ver planos disponíveis
                </ib-btn>
            </v-alert>
        </div>

        <v-card class="mb-4 nd-border" flat>
            <v-card-title>
                Follow-ups automáticos
            </v-card-title>

            <v-card-subtitle>
                Crie mensagens automáticas em todos os atendimentos para relembrar os contatos que deixam de interagir no meio da conversa. <ib-btn small @click="showVideo = true"><v-icon size="16" class="mr-1">mdi-help-circle-outline</v-icon>Saiba mais</ib-btn>
            </v-card-subtitle>

            <v-card-text v-if="selectedFollowUp">
                <v-row>
                    <v-col cols="12" lg="6">
                        <ib-select v-model="selectedChip" chips small-chips item-text="name" item-value="id" :items="chips" label="Chip" color="primary" outlined hide-details="auto" return-object/>
                    </v-col>
                    <v-col cols="12">
                        <v-switch inset v-model="selectedFollowUp.enabled" :label="selectedFollowUp.enabled ? 'Follow-ups Automáticos Ligados' : 'Follow-ups Automáticos Desligados'"></v-switch>
                    </v-col>
                </v-row>

                <v-row v-if="selectedFollowUp.enabled">
                    <v-col cols="12" lg="6" md="6" sm="12">
                        <ib-select v-model="selectedFollowUp.types" multiple clearable chips small-chips item-text="name" item-value="id" :items="types" label="Atuar em" color="primary" outlined hide-details="auto" />
                    </v-col>
                    <v-col cols="12" lg="3" md="3" sm="12">
                        <ib-text-field type="number" label="Não enviar antes do horário (0 a 23h)" v-model="selectedFollowUp.start_time" max="23" min="0" hide-details="auto"></ib-text-field>
                    </v-col>

                    <v-col cols="12" lg="3" md="3" sm="12">
                        <ib-text-field type="number" label="Não enviar após o horário (0 a 23h)" v-model="selectedFollowUp.end_time" max="23" min="0" hide-details="auto"></ib-text-field>
                    </v-col>

                    <v-col cols="12">
                        <ib-select v-model="selectedFollowUp.week_days" multiple chips small-chips item-text="name" item-value="id" :items="week_days" label="Enviar nos dias" color="primary" outlined hide-details="auto" />
                    </v-col>

                    <v-col cols="12">
                        <label><b>Você pode enviar até 3 mensagens de follow-up em uma mesma conversa.</b> Dica: evite ser insistente demais para não ter o número bloqueado / marcado como spam muitas vezes, pois isso pode causar banimento do chip.</label>
                    </v-col>
                </v-row>

                <div v-if="selectedFollowUp.enabled">
                    <v-row>
                        <v-col cols="12">
                            <label style="font-size: 16px; font-weight: bold;">1ª Mensagem</label>
                            <v-switch inset v-model="selectedFollowUp.message_1.enabled" :label="selectedFollowUp.message_1.enabled ? 'Ligado' : 'Desligado'" hide-details="auto"></v-switch>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea class="nd-text-field" label="Mensagem" placeholder="Escreva a mensagem aqui" v-model="selectedFollowUp.message_1.text" outlined rows="3" hide-details="auto"></v-textarea>
                        </v-col>

                        <v-col cols="12" lg="6" md="6" sm="12">
                            <ib-text-field type="number" label="Tempo" v-model="selectedFollowUp.message_1.time" hide-details="auto"></ib-text-field>
                        </v-col>

                        <v-col cols="12" lg="6" md="6" sm="12">
                            <ib-select v-model="selectedFollowUp.message_1.unit" mandatory chips small-chips item-text="name" item-value="id" :items="time_types" label="Unidade" color="primary" outlined hide-details="auto" />
                        </v-col>
                    </v-row>

                    <v-divider class="my-4"></v-divider>

                    <v-row>
                        <v-col cols="12">
                            <label style="font-size: 16px; font-weight: bold;">2ª Mensagem</label>
                            <v-switch inset v-model="selectedFollowUp.message_2.enabled" :label="selectedFollowUp.message_2.enabled ? 'Ligado' : 'Desligado'" hide-details="auto"></v-switch>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea class="nd-text-field" label="Mensagem" placeholder="Escreva a mensagem aqui" v-model="selectedFollowUp.message_2.text" outlined rows="3" hide-details="auto"></v-textarea>
                        </v-col>

                        <v-col cols="12" lg="6" md="6" sm="12">
                            <ib-text-field type="number" label="Tempo" v-model="selectedFollowUp.message_2.time" hide-details="auto" messages="Contado a partir do envio da 1ª mensagem de follow-up"></ib-text-field>
                        </v-col>

                        <v-col cols="12" lg="6" md="6" sm="12">
                            <ib-select v-model="selectedFollowUp.message_2.unit" mandatory chips small-chips item-text="name" item-value="id" :items="time_types" label="Unidade" color="primary" outlined hide-details="auto" />
                        </v-col>
                    </v-row>

                    <v-divider class="my-4"></v-divider>

                    <v-row>
                        <v-col cols="12">
                            <label style="font-size: 16px; font-weight: bold;">3ª Mensagem</label>
                            <v-switch inset v-model="selectedFollowUp.message_3.enabled" :label="selectedFollowUp.message_3.enabled ? 'Ligado' : 'Desligado'" hide-details="auto"></v-switch>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea class="nd-text-field" label="Mensagem" placeholder="Escreva a mensagem aqui" v-model="selectedFollowUp.message_3.text" outlined rows="3" hide-details="auto"></v-textarea>
                        </v-col>

                        <v-col cols="12" lg="6" md="6" sm="12">
                            <ib-text-field type="number" label="Tempo" v-model="selectedFollowUp.message_3.time" hide-details="auto" messages="Contado a partir do envio da 2ª mensagem de follow-up"></ib-text-field>
                        </v-col>

                        <v-col cols="12" lg="6" md="6" sm="12">
                            <ib-select v-model="selectedFollowUp.message_3.unit" mandatory chips small-chips item-text="name" item-value="id" :items="time_types" label="Unidade" color="primary" outlined hide-details="auto" />
                        </v-col>
                    </v-row>
                </div>

            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <ib-btn color="primary" class="mb-2" :loading="loading" @click.native="saveSelectedFollowUp">
                    Salvar
                </ib-btn>
            </v-card-actions>
        </v-card>

        <video-dialog v-model="showVideo" videoUrl="https://www.youtube.com/embed/p6AfkGjNcOM?rel=0" />
    </div>
</template>

<script>
import Api from "@/lib/Api";
import { emitToastr } from "@/lib/Utils";
import VideoDialog from "@/components/VideoDialog.vue";

export default {
    name: "AutoFollowUpView",

    components: {
        VideoDialog
    },

    data() {
        return {
            autoFollowUps: [],
            chips: [],
            selectedChip: {}, 
            showVideo: false,
            loading: false,
            types: [
                { name: 'Chatbots de IA', id: 'ai_chatbot' },
                { name: 'Chatbots de Fluxo', id: 'flow_chatbot' },
                { name: 'Atendimento humano', id: 'human' },
            ],
            time_types: [
                { name: 'Minutos', id: 'minutes' },
                { name: 'Horas', id: 'hours' }
            ],
            week_days: [
                { name: 'Segunda-feira', id: 1 },
                { name: 'Terça-feira', id: 2 },
                { name: 'Quarta-feira', id: 3 },
                { name: 'Quinta-feira', id: 4 },
                { name: 'Sexta-feira', id: 5 },
                { name: 'Sábado', id: 6 },
                { name: 'Domingo', id: 0 }
            ]
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.currentUser;
        },
        selectedFollowUp() {
            const chipId = this.selectedChip._id;
            return this.autoFollowUps.find(follow_up => follow_up.chip === chipId)
        }
    },

    async mounted() {
        await this.$store.dispatch('loadCurrentUser');
        this.load();
    },

    methods: {

        async load() {
            this.loading = true;

            const respAutoFollowUps = await Api.getAutoFollowUps();
            if (respAutoFollowUps.message) {
                respAutoFollowUps.message.forEach(follow_up => {
                    if (!follow_up.week_days?.length) follow_up.week_days = [1, 2, 3, 4, 5, 6, 0];
                });
                this.autoFollowUps = respAutoFollowUps.message;
            }
         
            const respChips = await Api.getChipNumbersByUser();
            if (respChips.message) {
                this.chips = respChips.message;
                this.selectedChip = this.chips[0] || null;
            }

            this.loading = false;
        },

        async saveSelectedFollowUp() {
            this.loading = true;

            const week_days_order = this.week_days.map(day => day.id);
            this.selectedFollowUp.week_days.sort((a, b) => week_days_order.indexOf(a) - week_days_order.indexOf(b));

            const resp = await Api.updateAutoFollowUp(this.selectedFollowUp);
            this.loading = false;

            if (!resp.error) {
                emitToastr("success", "Configurações atualizadas com sucesso!");
            }

        }
    },
};
</script>

<style scoped></style>